// Export all language prompts from a single file

const danishPrompts = require('./danish');
const englishPrompts = require('./english');
const norwegianPrompts = require('./norwegian');
const swedishPrompts = require('./swedish');

// Language codes mapped to their respective prompts
const languagePrompts = {
  da: danishPrompts,
  en: englishPrompts,
  no: norwegianPrompts,
  sv: swedishPrompts
};

// Available languages for the dropdown
const availableLanguages = [
  { code: 'da', name: 'Dansk' },
  { code: 'en', name: 'English' },
  { code: 'no', name: 'Norsk' },
  { code: 'sv', name: 'Svenska' }
];

// Default language
const defaultLanguage = 'en';

// Get prompt for specified language, with fallback to default
const getPromptByLanguage = (language = defaultLanguage) => {
  return languagePrompts[language] || languagePrompts[defaultLanguage];
};

module.exports = {
  availableLanguages,
  defaultLanguage,
  getPromptByLanguage,
  default: languagePrompts
}; 